'use strict';
/**
 * @author Maxim Seredkin
 * @param {$HttpProvider} $httpProvider
 */
export default ['$httpProvider',
    function($httpProvider) {
        $httpProvider.defaults.withCredentials = true;
        // interceptor
        $httpProvider.interceptors.push('errorInterceptor');
    }];
